import { render, staticRenderFns } from "./StudentQuestionsTable.vue?vue&type=template&id=7b791db3&"
import script from "./StudentQuestionsTable.vue?vue&type=script&lang=js&"
export * from "./StudentQuestionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports